import {
  MapPin, Layers, Camera, Landmark, Mic, StickyNote, Radar, ScanText,
  Timer, Bell, Compass, Footprints, WifiOff, Car, Users, Languages,
} from "lucide-react";
import { useI18n } from "@/lib/i18n";

const ICONS = [
  MapPin, Layers, Camera, Landmark, Mic, StickyNote, Radar, ScanText,
  Timer, Bell, Compass, Footprints, WifiOff, Car, Users, Languages,
];

export default function Solution() {
  const { t } = useI18n();
  const features = t("solution.features");

  return (
    <section className="section bg-brand-sand" data-testid="section-solution">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="eyebrow">{t("solution.eyebrow")}</div>
          <h2 className="h2 mt-4">{t("solution.title")}</h2>
          <p className="lede mt-5">{t("solution.lede")}</p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {features.map((f, i) => {
            const Icon = ICONS[i] || MapPin;
            return (
              <div
                key={i}
                className="group bg-white rounded-2xl border border-brand-line p-5 transition-transform duration-200 hover:-translate-y-1 hover:border-brand-green/40 hover:shadow-soft"
                data-testid={`solution-card-${i}`}
              >
                <div className="h-9 w-9 rounded-lg bg-brand-greenSoft flex items-center justify-center text-brand-green">
                  <Icon className="h-4.5 w-4.5" />
                </div>
                <div className="mt-4 text-sm font-semibold text-brand-charcoal leading-snug">
                  {f}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
